<script>
import LocationFormModal from '../modals/LocationFormModal.vue'
import {mapActions} from "vuex";
import Confirm from "../../../../../components/Confirm.vue";

export default {
  name: "DriverMasterGeneralWasteDisposalLocationBlock",
  components: {
    Confirm,
    LocationFormModal
  },
  mixins: [

  ],
  props: {
    targetTraderId: {
      type: [String, Number],
      default: () => null,
    }
  },
  data () {
    return {
      enableModal: false,
      targetLocationId: null,
      tableHeaders: [
        { value: 'code', text: '事業場コード', width: '10%' },
        { value: 'name', text: '事業場名', width: '30%' },
        { value: 'location_type_name', text: '事業場区分', width: '10%' },
        { value: 'address', text: '住所', width: '30%' },
        { value: 'phone_number', text: '電話番号', width: '10%' },
        { value: 'editable', text: '', align: 'end', width: '10%' },
      ],
      page: 1,
      totalVisible: 7,
      pagination: {
        total_pages: 0,
        total_count: 0
      },
      traderLocations: [],
    }
  },
  computed: {},
  watch: {},
  created () {
    this.search();
  },
  methods: {
    ...mapActions("DriverMasterGeneralWasteDisposalLocation", {
      fetchLocations: "index",
      deleteLocation: "destroy",
    }),
    addButtonClickEvent () {
      this.targetLocationId = null;
      this.enableModal = true;
    },

    editButtonClickEvent(item) {
      this.targetLocationId = item.id;
      this.enableModal = true;
    },
    deleteButtonClickEvent(item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteLocation({ trader_id: this.targetTraderId, id: item.id }).then(() =>{
            this.page = 1
            this.search()
          })
        }
      })
    },

    pageChangeEvent () {
      this.search();
    },

    modalCloseCallback () {
      this.enableModal = false;
    },

    modalRegisterCallback () {
      this.page = 1;
      this.search();
      this.modalCloseCallback();
    },

    search () {
      const params = { trader_id: this.targetTraderId, page: this.page }
      this.fetchLocations(params).then((content) => {
        this.traderLocations = content.trader_locations
        this.pagination = content.pagination
      })
    },

  },
}
</script>

<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col>
            <div
              class="text-right mb-3"
            >
              <v-btn
                color="primary"
                @click="addButtonClickEvent"
              >
                事業場の追加&nbsp;<v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
            <v-card outlined>
              <v-data-table
                :headers="tableHeaders"
                :items="traderLocations"
                :items-per-page="-1"
                dense
                disable-sort
                hide-default-footer
              >
                <template v-slot:[`item.name`]="{ item }">
                  <div class="line-clamp one-clamp" :title="item.name">{{ item.name }}</div>
                </template>

                <template v-slot:[`item.address`]="{ item }">
                  <div>〒{{ item.zip_code }}</div>
                  <div class="line-clamp one-clamp" :title="item.address">{{ item.address }}</div>
                </template>

                <template v-slot:[`item.editable`]="{ item }">
                  <v-btn
                    :icon="$vuetify.breakpoint.mdAndUp"
                    :small="$vuetify.breakpoint.smAndDown"
                    :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                    @click="editButtonClickEvent(item)"
                  >
                    <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                      mdi-file-edit-outline
                    </v-icon>
                    <span v-else>編集</span>
                  </v-btn>
                  <v-btn
                    :icon="$vuetify.breakpoint.mdAndUp"
                    :small="$vuetify.breakpoint.smAndDown"
                    :color="`error ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                    @click="deleteButtonClickEvent(item)"
                  >
                    <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                      mdi-trash-can-outline
                    </v-icon>
                    <span v-else>削除</span>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-pagination
              v-model="page"
              :length="pagination.total_pages"
              :total-visible="totalVisible"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              @input="pageChangeEvent"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <location-form-modal
      :enable-modal="enableModal"
      :trader-id="targetTraderId"
      :location-id="targetLocationId"
      @closeCallback="modalCloseCallback"
      @registerCallback="modalRegisterCallback"
    />
    <confirm ref="confirm" />
  </div>
</template>

<style scoped lang="scss">

</style>
